var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6826 26.6356C11.6826 25.1819 13.1275 20.7477 14.914 20.7477C16.7006 20.7477 18.1453 25.1819 18.1453 26.6356C18.1453 28.0896 16.7006 29.2768 14.914 29.2768C13.1014 29.301 11.6826 28.1138 11.6826 26.6356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0379 0C12.4832 0 10.4395 1.97218 10.4395 4.41867C10.4395 6.84027 12.5088 14.7539 15.0379 14.7539C17.5671 14.7539 19.6364 6.84027 19.6364 4.41867C19.6364 1.97218 17.5671 0 15.0379 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15283 15.1859C4.17689 16.2374 11.1576 17.8511 12.2734 15.9439C13.3895 14.0612 8.17332 9.36637 6.14925 8.31503C4.15078 7.28807 1.63382 7.97277 0.517765 9.8554C-0.598046 11.7627 0.154365 14.1345 2.15283 15.1859Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3226 9.92393C28.2073 7.98773 25.6919 7.25846 23.6687 8.33973C21.646 9.39583 16.4589 14.2241 17.548 16.1604C18.6634 18.0966 25.6657 16.4621 27.6629 15.3807C29.6855 14.3247 30.4118 11.8602 29.3226 9.92393Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96353 22.5553C5.55614 23.7987 7.07661 24.3317 8.33932 23.7227C9.60178 23.1387 12.9517 20.3217 12.3591 19.1035C11.7666 17.8598 7.43729 18.6466 6.17457 19.2303C4.91186 19.8394 4.37071 21.3116 4.96353 22.5553Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.869 19.2303C22.5683 18.6466 18.1085 17.8598 17.4717 19.1035C16.861 20.347 20.3118 23.1387 21.6125 23.7227C22.913 24.3317 24.4792 23.7987 25.0897 22.5553C25.727 21.3116 25.1694 19.8394 23.869 19.2303Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e739cba15db69a89bfa6f662354d91f3.svg";
export { ForwardRef as ReactComponent };